export const REACTIONS_SCOPE = 'block-reactions';
